import { FC, ReactNode } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames/bind';

interface IProps {
    onChange: (val: any) => void;
    tabs: {
        label: string;
        value: any;
        after?: ReactNode;
        before?: ReactNode;
    }[];
    activeTab: any;
    className?: string;
}

const cx = classNames.bind(styles);

const Tabs: FC<IProps> = ({ onChange, tabs, activeTab, className }) => {
    return (
        <div className={cx([styles.wrapper, className])}>
            {tabs.map((tab, i) => {
                return (
                    <div
                        className={cx([styles.tab, { isActive: tab.value === activeTab }])}
                        key={i}
                        onClick={() => onChange(tab.value)}>
                        {tab.before}
                        <p>{tab.label}</p>
                        {tab.after}
                    </div>
                );
            })}
        </div>
    );
};

export default Tabs;
